<template>
    <div>
        <!-- Modal Log de Comunicação de Autorização Online-->
        <div class="modal fade" id="solicitacaoAutorizacaoLogModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Log de Comunicação</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-if="dados" class="alert alert-info">
                            <div>#{{ dados.id_solicitacao_autorizacao }}</div>
                            <div v-if="dados.paciente">{{ dados.paciente.st_nome }}</div>
                            <div v-else-if="dados.cadastro_temporario">{{ dados.cadastro_temporario.st_nome }}</div>
                        </div>

                        <az-empty-state 
                            v-if="!dados || !dados.solicitacao_autorizacao_log || !dados.solicitacao_autorizacao_log.length" 
                            msg="Nenhum log identificado." />

                        <div v-else>
                            <div class="table-responsive">
                                <table class="table table-striped">
                                    <thead>
                                        <tr>
                                            <th>Data</th>
                                            <th>Envio</th>
                                            <th>Retorno</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(log, ilx) in dados.solicitacao_autorizacao_log" :key="ilx">
                                            <td class="small">
                                                <span v-if="log.created_at">
                                                    {{ $util.getFormatDate(log.created_at) }}
                                                    {{ log.created_at.slice(11,16) }}
                                                </span>
                                            </td>
                                            <td class="small">{{ log.st_xml_envio }}</td>
                                            <td class="small">{{ log.st_xml_retorno }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <pre v-if="false">{{ dados }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import AzEmptyState from '../../util/AzEmptyState.vue';

export default {
    data() {
        return {    
            dados: null, 
        }
    },

    components: { 
        AzEmptyState, 
    },

    methods: { 
        abrir (id_solicitacao_autorizacao) { 
            this.dados = null;
            $('#solicitacaoAutorizacaoLogModal').modal('show');

            this.$util.load(this, { 
                service: 'solicitacao_autorizacoes',
                func: 'show', 
                parms: { 
                    id: id_solicitacao_autorizacao, 
                    log_autoriz: true, 
                },
                loadTo: res => { 
                    this.dados = res;
                }
            });
        }
    }
}
</script>
